/* PRÁZDNÝ STAV — tlumená ikona, jedna věta, jedna akce.
 * ============================================================================
 *
 *   <PrazdnyStav
 *     ikona={CalendarDays}
 *     text={t("…zadneSchuzky")}
 *     akce={{ popisek: t("…naplanovat"), onClick: otevriDiar }}
 *   />
 *
 * Náhrada 🎉 👌 🌤️ v prázdných panelech (nástěnka, notifikace, diář).
 * Podle NN/g (Kaplan 2021): řekni, co tu je (nic), a nabídni JEDEN krok.
 *
 * ⚠️ PRÁZDNO NENÍ CHYBA. Když se data nenačetla, patří sem `ChybaNacteni`,
 * ne „Zatím tu nic není" — jinak poradce uvěří, že nemá žádné klienty.
 *
 * Tlačítko má výšku 44 px (dotyk na mobilu), fokus řeší globální
 * `:focus-visible`. Žádná oslava, žádný pohyb.
 *
 * `kompaktni` = panel nástěnky (okolní text 12–13 px): ikona 20 px, věta
 * v `text-maly` (13 px). Plná velikost (14 px) v úzkém panelu přebíjela
 * obsah okolních panelů.
 */
import { isValidElement } from "react";
import { Inbox } from "lucide-react";

function Akce({ akce }) {
  if (!akce) return null;
  if (isValidElement(akce)) return akce;
  const { popisek, onClick, href } = akce;
  if (!popisek) return null;
  const tridy = "inline-flex items-center justify-center min-h-[44px] px-4 rounded-full text-maly font-semibold transition-colors hover:bg-accent-soft";
  const vzhled = { border: "1px solid var(--line)", color: "var(--accent-ink)", background: "var(--surface)" };
  if (href) {
    return <a href={href} onClick={onClick} className={tridy} style={vzhled}>{popisek}</a>;
  }
  return <button type="button" onClick={onClick} className={tridy} style={vzhled}>{popisek}</button>;
}

/**
 * @param {Function} [ikona=Inbox]  lucide ikona (nebo doplněk)
 * @param {string}   text           jedna věta
 * @param {object|ReactElement} [akce]  { popisek, onClick, href } nebo hotový prvek
 * @param {boolean}  [kompaktni=false]  menší odsazení (panel na nástěnce)
 */
export default function PrazdnyStav({ ikona: Ikona = Inbox, text, akce, kompaktni = false, className = "", testid }) {
  return (
    <div
      data-testid={testid}
      className={`flex flex-col items-center justify-center text-center ${kompaktni ? "gap-1.5 py-5 px-3" : "gap-3 py-10 px-6"} ${className}`}
    >
      <Ikona size={kompaktni ? 20 : 32} strokeWidth={1.75} aria-hidden="true" style={{ color: "var(--faint)" }} />
      {text && <p className={`${kompaktni ? "text-maly" : "text-text"} max-w-sm m-0`} style={{ color: "var(--muted)" }}>{text}</p>}
      <Akce akce={akce} />
    </div>
  );
}
